export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6711.2b536a46.jpg";